import { Permission } from 'model';
import { useSelector } from 'react-redux';
import { RootState } from 'store/config';

const usePermission = (permission: Permission[0]): boolean => {
  // const { isAllowedTo } = useContext(PermissionContext);
  // return isAllowedTo(permission);
  const { userPermission } = useSelector((state: RootState) => state.auth);
  const userPermissionRole = userPermission[0];

  if (
    permission === 'company_admin' &&
    userPermissionRole === 'company_admin'
  ) {
    return true;
  } else if (
    permission === 'company_receptionist' &&
    (userPermissionRole === 'company_receptionist' ||
      userPermissionRole === 'company_admin')
  ) {
    return true;
  } else if (
    permission === 'company_staff' &&
    (userPermissionRole === 'company_receptionist' ||
      userPermissionRole === 'company_admin' ||
      userPermissionRole === 'company_staff')
  ) {
    return true;
  } else {
    return false;
  }
};

export default usePermission;
